import BaseClient from '@/app/model/api/response/baseApiClient'

class FieldOrderDownloadApi extends BaseClient {
  public doFieldOrderDownload (bodyData: any) {
    const path:string = '/v1/field/order/download'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }

  public doResponseConvert (response: any) {
    if (response.status === 200) {
      return response.blob()
    } else {
      return response.json()
    }
  }

  public getPayload (data: any) {
    if (Object.keys(data).indexOf('status_code') !== -1) {
      throw data
    } else {
      const outside: any = URL.createObjectURL(data)
      return outside
    }
  }
}

export default new FieldOrderDownloadApi()
